var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideBtnBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-1 0 0 1 48 0)",
    fill: "#161718"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6776 30.9217C22.084 28.5104 24.471 26.1186 26.8677 23.7316C27.0141 23.5852 27.0483 23.5071 26.8775 23.3411C26.1257 22.6138 25.3838 21.867 24.6516 21.1202C24.4563 20.92 24.3197 20.9054 24.1147 21.1153C21.84 23.3997 19.5604 25.6793 17.2809 27.9539C17.0905 28.1443 17.0368 28.2761 17.2565 28.4909C18.0716 29.2914 18.8673 30.1017 19.6825 30.9266L19.6776 30.9217Z",
    fill: "#C7D0CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2529 30.9953C28.5025 30.9953 29.7473 30.9953 30.9969 30.9953C30.9969 28.5889 30.992 26.1775 30.9871 23.771C30.3818 23.6637 29.7765 23.7271 29.1713 23.7271C28.5367 23.7271 27.8973 23.6637 27.2627 23.771C27.2627 26.1824 27.2578 28.5889 27.2529 31.0002L27.2529 30.9953Z",
    fill: "#C7D0CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2226 20.6561C24.2226 19.4358 24.2226 18.2203 24.2275 17C21.821 17 19.4145 17 17.0032 17C17.0032 18.2203 17.0032 19.4358 17.0081 20.6561C19.4096 20.6561 21.8161 20.6561 24.2177 20.6561L24.2226 20.6561Z",
    fill: "#C7D0CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2642 20.6561C28.5089 20.6561 29.7487 20.6561 30.9935 20.6561C30.9935 19.4358 30.9935 18.2154 30.9935 17C29.7487 17 28.504 17 27.2642 17C27.2642 18.2203 27.2642 19.4406 27.2642 20.661L27.2642 20.6561Z",
    fill: "#C7D0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBtnBlack);
export default __webpack_public_path__ + "static/media/side-btn-black.0e7abdea67c651d0b9903d094362adbd.svg";
export { ForwardRef as ReactComponent };